import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { FunctionComponent, useMemo } from 'react';
import Filter from './Filter/Filter';
import useOrganizationMarketplaces from 'hooks/useOrganizationMarketplaces';
import {
    isServiceCategoryEnabled,
    OrganizationServiceCategory
} from 'hooks/useOrganizationMarketplacesByServiceCategory';

const SERVICE_CATEGORY_LABELS: Record<OrganizationServiceCategory, string> = {
    boarding: 'Boarding',
    daycare: 'Daycare',
    training: 'Training',
    transportation: 'Transportation',
    walking: 'Walking',
    grooming: 'Grooming',
    evaluation: 'Evaluation'
};

interface OrganizationMarketplacesFilterProps {
    selected: Array<number>;
    singleSelection?: boolean;
    className?: string;
    serviceCategoryId?: OrganizationServiceCategory;
    onChangeSelection?: (selectedMarketplaceIds: Array<number>) => void;
}

export const OrganizationMarketplacesFilter: FunctionComponent<OrganizationMarketplacesFilterProps> = props => {
    const { organizationMarketplaces } = useOrganizationMarketplaces();

    const marketplaces = useMemo(
        () =>
            organizationMarketplaces
                .map(marketplace => {
                    const enabled =
                        !props.serviceCategoryId || isServiceCategoryEnabled(marketplace, props.serviceCategoryId);

                    return {
                        id: marketplace.id,
                        name: marketplace.name,
                        disabled: !enabled,
                        description:
                            !enabled && props.serviceCategoryId
                                ? `${SERVICE_CATEGORY_LABELS[props.serviceCategoryId]} is not enabled.`
                                : undefined
                    };
                })
                .sort((marketplace, otherMarketplace) => marketplace.name.localeCompare(otherMarketplace.name)),
        [organizationMarketplaces, props.serviceCategoryId]
    );

    return marketplaces.length > 1 ? (
        <Filter
            allLabel="All Locations"
            quantityLabel="locations"
            icon={faLocationDot}
            options={marketplaces}
            selectedOptions={marketplaces.filter(
                marketplace => !marketplace.disabled && props.selected.includes(marketplace.id)
            )}
            singleSelection={props.singleSelection}
            onChangeSelection={options => props.onChangeSelection?.(options.map(option => option.id))}
            className={props.className}
        />
    ) : null;
};

export default OrganizationMarketplacesFilter;
